// @ts-check
import { Bar, BarChart, Cell, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';

/** New vs returning customers bar for the range, with the total base and the change in new customers on the previous period. */
export default function CustomersBlock({ block }) {
  const { total_customers: totalCustomers = 0, new_in_range: newCount = 0, returning = 0, delta_pct: delta = null } = block.data || {};
  const rounded = delta === null || delta === undefined ? null : Math.round(delta);
  const bars = [
    { name: 'New', value: newCount, fill: '#3b82f6' },
    { name: 'Returning', value: returning, fill: '#8b5cf6' },
  ];

  return (
    <BlockCard title="Customers" href={block.href} headline={block.headline}>
      {newCount + returning > 0 ? (
        <div data-testid="customers-chart" className="overflow-x-auto">
          <BarChart width={240} height={110} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={12} />
            <YAxis hide allowDecimals={false} />
            <Bar dataKey="value" isAnimationActive={false}>
              {bars.map((b) => (
                <Cell key={b.name} fill={b.fill} />
              ))}
            </Bar>
          </BarChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No customer activity in this range</p>
      )}
      <ul className="mt-2 space-y-1 text-sm">
        <li data-testid="customers-new" className="flex justify-between"><span>New</span><span className="font-medium">{newCount}</span></li>
        <li data-testid="customers-returning" className="flex justify-between" title="Paid order in this range and an earlier paid order"><span>Returning (repeat buyers)</span><span className="font-medium">{returning}</span></li>
      </ul>
      <p className="mt-2 text-sm text-muted-foreground">
        <span data-testid="customers-total">{totalCustomers.toLocaleString('en-IN')} total</span>
        <span data-testid="customers-delta" className="ml-2">
          {rounded === null ? '—' : `${rounded > 0 ? '+' : ''}${rounded}%`} vs previous period
        </span>
      </p>
    </BlockCard>
  );
}
